import { Date, merge } from './main.js';

function createPcomponentParam(bundle) {
    const { actions, country, device, language, logger, modalRootContainer, tool, widgetName, } = bundle;
    const countdown = tool.getCountdown();
    const countdownTimestamp = countdown
        ? Date.now() + (countdown.secondsLeft * 1000)
        : undefined;
    const toolContext = tool.getContext();
    const toolJson = tool.getPayload();
    const toolJsonOverwrite = {
        // Temporary duplicate prop "toolId" as "id" (expected that way on p-components)
        // hopefully p-components will be updated to read "toolId" so that next-line can be removed
        id: toolJson.toolId,
        tokens: tool.getAllTokens(),
    };
    return {
        tool: merge(toolJson, toolJsonOverwrite),
        context: {
            ...toolContext,
            firstVisitDate: null,
            actions: actions,
            countdownTimestamp,
            currentCountry: country,
            deviceViewport: device,
            language: language?.replace(/_/g, '-'),
            logger,
            modalRootContainer,
            widgetName,
        },
    };
}

export { createPcomponentParam };
